import { createSelector } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import type { ProfileFull } from '../@types/Profile';
import type { Token } from '../@types/Token';
import type { RootState } from '../reducers';

export const getProfile = createSelector(
  (state: RootState) => state.auth.profile,
  (state: RootState) => state.auth.token,
  (profile, token) => {
    if (!token || !profile) return null;

    try {
      const data = jwtDecode<Token>(token);
      const fullProfile: ProfileFull = {
        ...profile,
        id: data.sub,
        email: data.email,
      };
      return fullProfile;
    } catch (_e) {
      return null;
    }
  },
);
